import React, { useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Button from '../components/common/Button';
import './SubscriptionSuccess.css';

const SubscriptionSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    // Could verify the session here if needed
    console.log('Checkout session:', sessionId);
  }, [sessionId]);

  return (
    <div className="subscription-success-page">
      <div className="success-container">
        <div className="success-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>

        <h1>Welcome to Three Plates!</h1>
        <p className="success-message">
          Your subscription is now active. You have full access to all features.
        </p>

        <div className="success-actions">
          <Link to="/coach/dashboard">
            <Button variant="primary" size="lg">
              Go to Dashboard
            </Button>
          </Link>
          <Link to="/coach/workouts/create">
            <Button variant="outline" size="lg">
              Create Your First Program
            </Button>
          </Link>
        </div>

        <p className="success-note">
          Need help getting started? Check out our <a href="/guide">quick start guide</a>.
        </p>
      </div>
    </div>
  );
};

export default SubscriptionSuccess;
